<template>
   <svg width="18" height="18" viewBox="0 0 22 22" fill="none" aria-hidden="true" focusable="false">
      <rect x="0.5" y="0.5" width="21.2493" height="21.5" rx="1" fill="#0078D4" />
      <path
         fill-rule="evenodd"
         clip-rule="evenodd"
         d="M10.9995 17.1109C13.9593 17.1109 16.3588 15.4733 16.3588 11.3128C16.3588 7.15218 13.9593 5.51465 10.9995 5.51465C8.03959 5.51465 5.64014 7.34386 5.64014 11.3128C5.64014 15.4733 8.03959 17.1109 10.9995 17.1109ZM10.9993 15.105C12.7129 15.105 14.102 14.0339 14.102 11.3127C14.102 8.59144 12.7129 7.52041 10.9993 7.52041C9.28566 7.52041 7.8965 8.71681 7.8965 11.3127C7.8965 14.0339 9.28566 15.105 10.9993 15.105Z"
         fill="white"
         fill-opacity="1"
      />
   </svg>
</template>
